import { render, staticRenderFns } from "./x-icon.vue?vue&type=template&id=f84b16de&scoped=true&"
import script from "./x-icon.vue?vue&type=script&lang=js&"
export * from "./x-icon.vue?vue&type=script&lang=js&"
import style0 from "./x-icon.vue?vue&type=style&index=0&id=f84b16de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84b16de",
  null
  
)

export default component.exports